import React from 'react';
import {lovLabel, lovValue} from 'core/form/formUtils';
import {joinNonNull} from 'core/common/utils/arrayUtils';
import {grey300} from "material-ui/styles/colors";
import 'invoice/component/invoiceSumTable.less';
import {observer} from "mobx-react";
import {Invoice, INVOICE_TYPE} from "invoice/domain/invoiceDomain";
import MdEntity from "core/metamodel/mdEntity";
import {ObservableMap} from "mobx";
import {classNames} from "core/common/utils/domUtils";
import { roundTo } from '../../core/common/utils/numberUtils';

interface InvoiceSumTableProps {
  invoiceObject: Invoice;
  invoiceEntity: MdEntity;
  entities: ObservableMap<MdEntity>;
  style: any;
  minimal?: boolean;
}

@observer
export default class InvoiceSumTable extends React.Component<InvoiceSumTableProps, undefined> {


  render() {

    const {invoiceObject, entities, invoiceEntity, style, minimal} = this.props;

    // basePrice = (sum(item.basePrice))cr
    // itemAdjustmentAmount = (sum(item.adjustmentAmount))cr
    // basePriceWithAdjustment =  basePrice + itemAdjustmentAmount
    // invoiceAdjustmentAmount = (basePriceWithAdjustment * invoiceAdjustmentKoef)cr
    // priceWithoutVat = basePriceWithAdjustment + invoiceAdjustmentAmount
    // vatAmount = (sum(item.vatAmount))cr
    // totalPrice = priceWithoutVat + vatAmount
    // Prejmenovani na Invoice:
    //
    //   totalAdjustmentAmount -> itemAdjustmentAmount
    // totalAdjustmentAmountLcy -> itemAdjustmentAmountLcy
    // totalAdjustmentKoef -> itemAdjustmentKoef

    let basePrice = invoiceEntity.getField('basePrice'),
      itemAdjustmentAmount = invoiceEntity.getField('itemAdjustmentAmount'),    // Sum (invoiceItem.adjustmentAmount)
      itemAdjustmentKoef = invoiceEntity.getField('itemAdjustmentKoef'),    // itemAdjustmentAmount / basePrice
      basePriceWithAdjustment = invoiceEntity.getField('basePriceWithAdjustment'),    // basePrice + itemAdjustmentAmount
      invoiceAdjustmentKoef = invoiceEntity.getField('invoiceAdjustmentKoef'),    // zadano
      invoiceAdjustmentAmount = invoiceEntity.getField('invoiceAdjustmentAmount'),    // (basePriceWithAdjustment * invoiceAdjustmentKoef)cr
      priceWithoutVat = invoiceEntity.getField('priceWithoutVat'),
      vatAmount = invoiceEntity.getField('vatAmount'),
      totalPrice = invoiceEntity.getField('totalPrice'),    // sum (invoiceItem.itemPrice)
      pennyAdjustment = invoiceEntity.getField('pennyAdjustment'),
      totalAdjustedPrice = invoiceEntity.getField('totalAdjustedPrice'),

      invoiceCurrencyLabel = lovLabel(invoiceObject.invoiceCurrency),
      invoiceCurrencyValue = lovValue(invoiceObject.invoiceCurrency),
      localCurrencyLabel = lovLabel(invoiceObject.localCurrency),
      localCurrencyValue = lovValue(invoiceObject.localCurrency)
      ;

    const vatRecapEntries = (invoiceObject.vatRecap) ? invoiceObject.vatRecap.entries() : null;
    invoiceObject.monetaryRounding
    let unpaidPrice = (lovValue(invoiceObject.invoiceType) == INVOICE_TYPE.CN) ? 0 : invoiceObject.totalAdjustedPrice - invoiceObject.paidAmount;
    let unpaidPriceLcy = (invoiceObject.totalAdjustedPrice && invoiceCurrencyValue !== localCurrencyValue) ? roundTo(unpaidPrice * (invoiceObject.totalAdjustedPriceLcy / invoiceObject.totalAdjustedPrice), 2) : null;


    return (


      <table className="invoice-sum-table" style={style}>
        <thead>
        <tr>
          <th style={{backgroundColor: grey300}}/>
          {(invoiceObject.itemAdjustmentAmount || invoiceObject.invoiceAdjustmentAmount) ? <th>{basePrice.gridHeaderLabelActive}</th> : null}
          {(invoiceObject.itemAdjustmentAmount) ? <th>{itemAdjustmentAmount.gridHeaderLabelActive}</th> : null}
          {(invoiceObject.invoiceAdjustmentAmount) ? <th>{invoiceAdjustmentAmount.gridHeaderLabelActive}</th> : null}
          <th>{priceWithoutVat.gridHeaderLabelActive}</th>
          <th>{vatAmount.gridHeaderLabelActive}</th>
          <th>{totalPrice.gridHeaderLabelActive}</th>
          {(invoiceObject.pennyAdjustment || invoiceObject.pennyAdjustmentLcy) ? <th>{pennyAdjustment.gridHeaderLabelActive}</th> : null}
          {(invoiceObject.pennyAdjustment || invoiceObject.pennyAdjustmentLcy) ? <th>{totalAdjustedPrice.gridHeaderLabelActive}</th> : null}
          {(unpaidPrice || unpaidPriceLcy) ? <th>Unsettled</th> : null}
        </tr>
        </thead>
        <tbody>
          <tr>
            <td>{invoiceCurrencyLabel}</td>
            {(invoiceObject.itemAdjustmentAmount || invoiceObject.invoiceAdjustmentAmount) ? <td>{basePrice.formatValue(invoiceObject.basePrice)}</td> : null}
            {(invoiceObject.itemAdjustmentAmount) ? <td> <div>{itemAdjustmentAmount.formatValue(invoiceObject.itemAdjustmentAmount)}</div><div style={{fontSize: 10}}>{itemAdjustmentKoef.formatValue(invoiceObject.itemAdjustmentKoef)}</div>  </td> : null}
            {(invoiceObject.invoiceAdjustmentAmount) ? <td>{invoiceAdjustmentAmount.formatValue(invoiceObject.invoiceAdjustmentAmount)}</td> : null}
            <td>{priceWithoutVat.formatValue(invoiceObject.priceWithoutVat)}</td>
            <td>{vatAmount.formatValue(invoiceObject.vatAmount)}</td>
            <td className={classNames({'color-green-500': !unpaidPrice && !invoiceObject.pennyAdjustment}, {"invoice-sum-table--big": !minimal})}>{ joinNonNull([totalPrice.formatValue(invoiceObject.totalPrice), invoiceCurrencyLabel], ' ')}</td>
            {(invoiceObject.pennyAdjustment || invoiceObject.pennyAdjustmentLcy) ? <td>{pennyAdjustment.formatValue(invoiceObject.pennyAdjustment)}</td> : null}
            {(invoiceObject.pennyAdjustment || invoiceObject.pennyAdjustmentLcy) ? <td className={classNames({'color-green-500': !unpaidPrice}, {"invoice-sum-table--big": !minimal})}>{totalAdjustedPrice.formatValue(invoiceObject.totalAdjustedPrice) + ' ' + invoiceCurrencyLabel}</td> : null}
            {(unpaidPrice) ? <td className={classNames("color-red-500", {"invoice-sum-table--big": !minimal})}>{totalAdjustedPrice.formatValue(unpaidPrice) + ' ' + invoiceCurrencyLabel}</td> : null}
          </tr>
          {(invoiceCurrencyValue !== localCurrencyValue) ? (
            <tr>
              <td>{localCurrencyLabel}</td>
              {(invoiceObject.itemAdjustmentAmountLcy || invoiceObject.invoiceAdjustmentAmountLcy) ? <td>{basePrice.formatValue(invoiceObject.basePriceLcy)}</td> : null}
              {(invoiceObject.itemAdjustmentAmountLcy) ? <td> <div>{itemAdjustmentAmount.formatValue(invoiceObject.itemAdjustmentAmountLcy)}</div><div style={{fontSize: 10}}>{itemAdjustmentKoef.formatValue(invoiceObject.itemAdjustmentKoef)}</div>  </td> : null}
              {(invoiceObject.invoiceAdjustmentAmountLcy) ? <td>{invoiceAdjustmentAmount.formatValue(invoiceObject.invoiceAdjustmentAmountLcy)}</td> : null}
              <td>{priceWithoutVat.formatValue(invoiceObject.priceWithoutVatLcy)}</td>
              <td>{vatAmount.formatValue(invoiceObject.vatAmountLcy)}</td>
              <td className={classNames({'color-green-500': !unpaidPriceLcy && !invoiceObject.pennyAdjustmentLcy}, {"invoice-sum-table--big": !minimal})}>{joinNonNull([totalPrice.formatValue(invoiceObject.totalPriceLcy), localCurrencyLabel], ' ')}</td>
              {(invoiceObject.pennyAdjustment || invoiceObject.pennyAdjustmentLcy) ? <td>{pennyAdjustment.formatValue(invoiceObject.pennyAdjustmentLcy)}</td> : null}
              {(invoiceObject.pennyAdjustment || invoiceObject.pennyAdjustmentLcy) ? <td className={classNames({'color-green-500': !unpaidPriceLcy}, {"invoice-sum-table--big": !minimal})}>{totalAdjustedPrice.formatValue(invoiceObject.totalAdjustedPriceLcy) + ' ' + localCurrencyLabel}</td> : null}
              {(unpaidPriceLcy) ? <td className={classNames("color-red-500", {"invoice-sum-table--big": !minimal})}>{totalAdjustedPrice.formatValue(unpaidPriceLcy) + ' ' + localCurrencyLabel}</td> : null}
            </tr>
          ) : null}

          {(vatRecapEntries && vatRecapEntries.length) ? <tr><td colSpan={9} style={{textAlign: 'left', borderLeft: '0', borderRight: '0'}}>{'VAT Recapitulation'}</td></tr> : null}

          {(vatRecapEntries && vatRecapEntries.length) ? (
            vatRecapEntries.map(pair => (
              <tr key={pair[0]}>
                <td>{itemAdjustmentKoef.formatValue(pair[0])}</td>
                {(invoiceObject.itemAdjustmentAmount|| invoiceObject.invoiceAdjustmentAmount) ? <td/> : null}
                {(invoiceObject.itemAdjustmentKoef) ? <td/> : null}
                {(invoiceObject.itemAdjustmentAmount) ? <td/> : null}
                {(invoiceObject.itemAdjustmentAmount) ? <td/> : null}
                {(invoiceObject.invoiceAdjustmentKoef) ? <td/> : null}
                {(invoiceObject.invoiceAdjustmentAmount) ? <td/> : null}
                <td>{priceWithoutVat.formatValue(pair[1].basisLcy)}</td>
                <td>{vatAmount.formatValue(pair[1].amountLcy) + ' ' + localCurrencyLabel}</td>
              </tr>
            ))
          ) : null}

        </tbody>
      </table>

    );
  }
}




// WEBPACK FOOTER //
// ./src/invoice/component/invoiceSumTable.tsx